import { render } from "./DuelsGameWinner.vue?vue&type=template&id=6640ea2b&scoped=true"
import script from "./DuelsGameWinner.vue?vue&type=script&lang=js"
export * from "./DuelsGameWinner.vue?vue&type=script&lang=js"

import "./DuelsGameWinner.vue?vue&type=style&index=0&id=6640ea2b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6640ea2b"]])

export default __exports__